import React from 'react';
import { ButtonCommon } from '../Button/ButtonCommon';
import { Info } from '@phosphor-icons/react/dist/ssr';
import { Debt } from 'models/Debt';
import { formatPrice } from 'utils';
import dayjs from 'dayjs';
import { Tag } from 'antd';
import { getStatusInfo } from 'utils/debt';
import HorizontalScrollContainer from '../ScrollContainer/HorizontalScrollContainer';
import { DebtStatusCode } from 'models';
interface DebtCustomerCardProps {
  debt: Debt;
  onClick?: (id: string) => void;
}

const DebtCustomerCard: React.FC<DebtCustomerCardProps> = ({ debt, onClick }) => {
  // Format month and day from the deadline
  const month = dayjs(debt.createdAt).format('M');
  const day = dayjs(debt.createdAt).format('D');

  const isOverdue =
    debt.status.code !== DebtStatusCode.COMPLETED && debt.deadline && dayjs(debt.deadline).isBefore(dayjs(), 'day');
  const isCompleted = debt.status.code === DebtStatusCode.COMPLETED;

  const statusCode =
    isOverdue && debt.status.code !== DebtStatusCode.COMPLETED && debt.status.code !== DebtStatusCode.CONFIRMING
      ? DebtStatusCode.OVERDUE
      : debt.status.code;

  const statusInfo = getStatusInfo(statusCode, debt?.cashFlow);
  const cardBgClass = isOverdue ? 'bg-rose-50' : isCompleted ? 'bg-green-50' : 'bg-white';

  return (
    <div className={`flex ${cardBgClass} shadow-sm border-l-8 ${statusInfo.borderColor}`}>
      <HorizontalScrollContainer className='flex-1 w-0' contentClassName='h-20' showArrows={true}>
        <div className='flex h-20 pl-6 py-3 min-w-[1000px]'>
          {/* Month and Day */}
          <div className='w-20 flex-shrink-0 flex flex-col justify-between'>
            <div className='text-black/60 text-sm font-medium'>Tháng {month}</div>
            <div className='text-black text-xl !leading-[20px] font-bold'>{day}</div>
          </div>

          {/* Debt Code */}
          <div className='w-44 flex-shrink-0 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Mã công nợ</div>
            <div className='text-black text-xl !leading-[20px] font-bold'>{debt.code}</div>
          </div>

          {/* Customer Name */}
          <div className='w-48 flex-shrink-0 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Khách hàng </div>
            <div className='text-black text-sm font-bold truncate'>
              {debt.name} - {debt.phoneNumber}
            </div>
          </div>

          {/* Transaction Type */}
          <div className='w-34 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Loại giao dịch</div>
            <Tag className='bg-black/5 text-black rounded-full border-0 px-4 py-1'>
              {debt.refTable === 'SaleOrders' ? 'Bán hàng' : 'Nhập hàng'}
            </Tag>
          </div>

          {/* Total Amount */}
          <div className='w-36 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Tổng tiền</div>
            <div className='text-black/60 text-sm font-bold'>{formatPrice(debt.totalAmount)} VND</div>
          </div>

          {/* Paid Amount */}
          <div className='w-36 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Đã thanh toán</div>
            <div className='text-black/60 text-sm font-bold'>{formatPrice(debt.paidAmount)} VND</div>
          </div>

          {/* Remaining Amount */}
          <div className='w-36 flex-shrink-0 px-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Còn lại</div>
            <div className={`text-${statusInfo.color} text-sm font-bold`}>{formatPrice(debt.remainingAmount)} VND</div>
          </div>

          {/* Status */}
          <div className='flex-1 min-w-[120px] pl-3 flex flex-col justify-between'>
            <div className='text-black/60 text-sm'>Trạng thái</div>
            <Tag
              className={`${statusInfo.bgColor} text-white rounded-full text-md border-0 px-4 py-1 max-w-fit text-center !m-0`}
            >
              {statusInfo.text}
            </Tag>
          </div>
        </div>
      </HorizontalScrollContainer>

      <div className={`w-[140px] flex-shrink-0 h-20 flex items-center justify-center border-l ${cardBgClass}`}>
        <ButtonCommon color='text' size='sm' onClick={() => onClick?.(debt.id)} icon={<Info size={20} />}>
          Xem chi tiết
        </ButtonCommon>
      </div>
    </div>
  );
};

export default DebtCustomerCard;
